import Grid from '@jobcost-monorepo/crud/ui/Grid';
import {
  IListOrderFetchParams,
  IOrder,
  MN_ORDERS,
} from '@jobcost-monorepo/crud';

export default function OrdersPage() {
  return (
    <Grid<IOrder, IListOrderFetchParams>
      moduleName={MN_ORDERS}
      updateStore={false}
    ></Grid>
  );
}
